export const isScrolledIntoView = (element, fullyInView) => {
    var rect = element.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;

    // Only completely visible elements return true:
    if (fullyInView) {
        return (elemTop >= 0) && (elemBottom <= window.innerHeight);
    }
    // Partially visible elements return true:
    return elemTop < window.innerHeight && elemBottom >= 0;
}

export const getScrolledPassedViewPercentage = (element) => {
    // Get the relevant measurements and positions
    const viewportHeight = window.innerHeight;
    const scrollTop = window.scrollY;
    const elementOffsetTop = element.offsetTop;
    const elementHeight = element.offsetHeight;

    // Calculate percentage of the element that's been seen
    const distance = (scrollTop + viewportHeight) - elementOffsetTop;
    const percentage = Math.round(distance / ((viewportHeight + elementHeight) / 100));

    // Restrict the range to between 0 and 100
    return Math.min(100, Math.max(0, percentage));
}